import * as React from 'react'
import { Keyboard, KeyboardEvent, Platform, StyleProp, View, ViewStyle } from 'react-native'
import styled from '@theme/styled-components'

interface Props {
  children: React.ReactNode
  style?: StyleProp<ViewStyle>
}

const OFFSET = 75

/**
 * Keyboard View calculating Keyboard height when appears
 * /!\ this componount is simple and only wrap content with a padding view, it does not calculate if keyboard is over content
 */
const KeyboardView = ({ children, style }: Props) => {
  const [keyboard, setKeyboard] = React.useState(1)

  React.useEffect(() => {
    Keyboard.addListener('keyboardDidShow', onKeyboard)
    Keyboard.addListener('keyboardWillHide', onKeyboardHide)

    return () => {
      Keyboard.removeAllListeners('keyboardDidShow')
      Keyboard.removeAllListeners('keyboardWillHide')
    }
  }, [])

  const onKeyboard = (event: KeyboardEvent) => {
    // android use keyboard avoid natively
    if (Platform.OS === 'ios') {
      setKeyboard(event.endCoordinates.height)
    }
  }

  const onKeyboardHide = (event: KeyboardEvent) => {
    // android use keyboard avoid natively
    if (Platform.OS === 'ios') {
      setKeyboard(1)
    }
  }

  return (
    <Wrapper keyboard={keyboard} style={style}>
      {children}
    </Wrapper>
  )
}

export default KeyboardView

const Wrapper = styled(View)<{ keyboard: number }>`
  padding-bottom: ${(props) => props.keyboard + OFFSET}px;
`
